import { useWatch } from 'react-hook-form'

import { useFormContext } from './useForm'

export const FormFieldWatch = ({ name, defaultValue, children, ...props }) => {
  const { control } = useFormContext()
  const watchValue = useWatch({ name, control, defaultValue })

  return children(watchValue)
}

export default FormFieldWatch
